<div class="bg-white order-details-shadow rounded-[8px]">
    <div class="flex py-[20px] px-[16px] justify-between">
        <div >
            <div (click)="showOrderPreview()" class="flex text-[13px] font-semibold">
                <div class="w-[21px] items-center mr-[15px] flex"><img *ngIf="showContent"
                        src="/assets/icons/Icon-Arrow-2-Left.svg" class="w-full h-[21px] rotate-90" /><img
                        *ngIf="!showContent" src="/assets/icons/Icon-Arrow-2-Left.svg"
                        class="w-full h-[21px] -rotate-90" /></div>
               {{brand}}
            </div>
        </div>
        <div class="text-[13px]">#{{id}}</div>
        <div (click)="openOrderDetails.emit(id)" class="flex items-center"><img
            src="/assets/icons/Icon-Arrow-1-Right.svg" class="w-[20px] h-[20px]" /></div>
    </div>
    <ng-content *ngIf="showContent"></ng-content>
</div>